import React from 'react';
import './App.css';
import stephen_pic from './stephen.png';
import gym_pic from './gym.png';
import Ayuda_pic from './Ayuda.png';
import fpt_pic from './fpt.png';
import skanlog_pic from './skanlog.png';
import Collapsible from 'react-collapsible';
function App() {
  return (

    <div className="App" >

      {/* //navBar */}
      <div id="main" className="follow">
        <div className="menudiv"><a className="aMenu" href="#contactMe">Contact</a></div>
        <div className="menudiv"><a className="aMenu" href="#skills">Skills</a></div>
        <div className="menudiv"><a className="aMenu" href="#projects">Projects</a></div>
        <div className="menudiv"><a className="aMenu" href="#about">About</a></div>
      </div>

      {/* Heading */}
      <header className="App-header">
        <img src={stephen_pic} className="App-logo" alt="logo" />
        <center>
          <p className="welcome-font">Welcome to my Portfolio!</p>
        </center>
      </header>

      {/* Body */}
      <div className="body">
        {/* About */}
        <hr></hr>
        <div>
          <p id="about">ABOUT</p>
          <p className="about">Hi, I am Stephen Dominic Almacen. I graduated last May 2019 at the University of San Carlos, BSIT.
        </p>
          <p className="about">I am currently working as a software engineer at a company. I am one of the persons who create, maintain, and test software.
        </p>
          <p className="about">I am a goal-oriented person, and I am more than willing to learn new technologies that can help me grow as a developer. As a teammate, I am easy to talk to, and I am friendly with my co-workers. Someday, I aspire to be a leader who guides the team to victory!
        </p>
        </div>
        {/* Projects */}
        <hr></hr><br />
        <div>
          <p id="projects">PROJECTS</p>
          <div className="divClassProjects">
            <br />
            <Collapsible trigger="Simple Gym Application">
              <br />
              <img src={gym_pic} className="projects-logo" alt="logo" />
              <ul>
                <li className="projects">Simple Android Application that acts as a guide to users on what exercises are to be done for specific body part targets.</li>
                <li className="projects">Used Android Studio.</li>
                <li className="projects">Implemented User Login and Register modules for the users.</li>
                <li className="projects">Implemented step counter using gyroscope.</li>
              </ul>
            </Collapsible>
            <br />
          </div>
          <div className="divClassProjects">
            <br />
            <Collapsible trigger="Ayuda: A Web and Mobile Portal Connecting Local Organizations and Volunteers">
              <br />
              <img src={Ayuda_pic} className="projects-logo" alt="logo" />
              <ul>
                <li className="projects">A Thesis project where a web and android portal is developed for non-profit           organizations(NGOs) for them to host events and for local volunteers to join and donate to an event.</li>
                <li className="projects">Used Android Studio, Java, Firebase Database REST API, Google APIs.</li>
                <li className="projects">Developed a native android application that acts like a bridge to local organizations(NGOs) and volunteers.</li>
                <li className="projects">Implemented CRUD functionalities, android application side, for the admin, NGOs, and for the local volunteers using firebase REST API.</li>
                <li className="projects">Used Firebase as the database to unify the data that are used for both web and android portals.</li>
                <li className="projects">Implemented sms and email for reporting/communication module.</li>
                <li className="projects">Used Google Maps functionality.</li>
                <li className="projects">Implemented filter system for the data to be displayed.</li>
                <li className="projects">Gathered user needs and feedback and updated code according to client needs.</li>
                <li className="projects">Implemented Notification module using Android studio library.</li>
                <li className="projects">Deployed to Google Play Store</li>
              </ul>
            </Collapsible>
            <br />
          </div>
          <div className="divClassProjects">
            <br />
            <Collapsible trigger="FPT Attendance Viewer">
              <br />
              <img src={fpt_pic} className="projects-logo" alt="logo" />
              <ul>
                <li className="projects">An internal project where me and my team are tasked is to create a local attendance system using spring boot and angular.</li>
                <li className="projects">Used Spring boot and angular and mysql.</li>
                <li className="projects">Implemented CRUD functionalities for the shift module.</li>
              </ul>
            </Collapsible>
            <br />
          </div>
          <div className="divClassProjects">
            <br />
            <Collapsible trigger="LOPO : Skanlog User Portal">
              <br />
              <img src={skanlog_pic} className="projects-logo" alt="logo" />
              <ul>
                <li className="projects">An OJT project where we are tasked to develop and update a web application.</li>
                <li className="projects">Used MySQL and ASP .NET.</li>
                <li className="projects">Implemented CRUD functionalities for Login and Register Modules.</li>
                <li className="projects">Updated functionality where we added specific user roles.</li>
              </ul>
            </Collapsible>
            <br />
          </div>
          <br />
          {/* Skills */}
          <hr></hr><br />
          <p id="skills">SKILLS</p>
          <div class="columns">
            <div>
              <ul>
                <li className="projects">Experience with NodeJs, EJS, and MongoDB</li>
                <li className="projects">Experience with JavaScript Programming</li>
                <li className="projects">PHP </li>
                <li className="projects">MySQL</li>
                <li className="projects">spring boot java </li>
                <li className="projects">Native Android Development</li>
                <li className="projects">Java OOP and Java Framework </li>
              </ul>
            </div>
            <div>
              <ul>
                <li className="projects">Angular</li>
                <li className="projects">React</li>
                <li className="projects">ASP .NET</li>
                <li className="projects">Selenium, TestNG</li>
                <li className="projects">Jenkins</li>
                <li className="projects">Git</li>
              </ul>
            </div>
          </div>
        </div>
        <hr></hr><br />
        <div id="contactMe" className="footer">
          <p>Contact Me Here!</p>
          <a href="https://www.facebook.com/steftoy" target="_blank" className="fa fa-facebook"></a>
          <a href="https://www.linkedin.com/in/stephen-almacen-5a435a196/" target="_blank" className="fa fa-linkedin"></a>
          <a href="skype:live:stephendominicalmacen?chat" className="fa fa-skype"></a>
          <a href="mailto:stephendominicalmacen@gmail.com" className="fa fa-google"></a>
        </div>
        <br />



      </div>
    </div>
  );
}

export default App;
